// extracted by mini-css-extract-plugin
export default {"buttonContent":"f7rJJAun","icon":"ItofD0fb"};